module.exports = __webpack_public_path__ + "static/media/atrias-corner-red.c921840a.svg";